import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, makeStyles } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import Button from 'Components/UI/Button';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2, 1, 2),
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  count: {
    marginLeft: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    borderRadius: '50%',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    fontWeight: theme.typography.fontWeightBold,
    height: 24,
    width: 24,
    lineHeight: '24px',
    fontSize: 12,
  },
}));

export default function GoalsHeader(props) {
  const { count, title, addGoal } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.title}>
        <Typography variant="h2" color="primary">
          {title}
        </Typography>
        <Box component="span" className={classes.count}>
          {count}
        </Box>
      </Box>
      {addGoal
        && (
          <Button
            onClick={() => openModal(modalConsts.goalModal)}
            color="secondary"
            endIcon={<AddCircleIcon color="secondary" fontSize="default" />}
          >
            {'Add Goal'}
          </Button>
        )}
    </Box>
  );
}

GoalsHeader.propTypes = {
  count: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  addGoal: PropTypes.bool.isRequired,
};
